(() => {
  // app/scripts/mega-tab-component.js
  var MegaTab = class extends HTMLElement {
    constructor() {
      super();
      const { editor } = theme;
      this.querySelectorAll(".jsMegaTabTitle")?.forEach((item) => {
        item.addEventListener("click", this.changeTab.bind(this));
        item.addEventListener("tabChange", this.changeTab.bind(this));
      });
      editor && this.querySelectorAll(".jsMegaTabContent")?.forEach((item) => {
        item.addEventListener("tabChangeContent", this.changeTabContent.bind(this));
      });
    }
    changeTabContent(e) {
      const element = e.target.closest(".jsMegaTabContent");
      const dataTabId = element.dataset.tabId;
      const elementTitle = this.querySelector(`[data-tab-id="${dataTabId}"].jsMegaTabTitle`);
      this.removeActiveTab();
      element.classList.add("active");
      if (elementTitle) {
        elementTitle.classList.add("active", "highlight");
      }
    }
    changeTab(e) {
      const element = e.target.closest(".jsMegaTabTitle");
      const dataTabId = element.dataset.tabId;
      const elementContent = this.querySelector(`[data-tab-id="${dataTabId}"].jsMegaTabContent`);
      this.removeActiveTab();
      element.classList.add("active", "highlight");
      if (elementContent) {
        elementContent.classList.add("active");
      }
    }
    removeActiveTab() {
      this.querySelectorAll(`[data-tab-id].active`)?.forEach((i) => {
        i.classList.remove("active", "highlight");
      });
    }
  };
  customElements.define("mega-tab", MegaTab);
})();
